// src/pages/ContactUs.js
/* eslint-disable */
import React from 'react';
import WebpageShell from './WebpageShell';
import HelmetTemplate from '../utils/HelmetTemplate';
import ContactMap from '../components/ContactMap';
import ContactInfoBoxes from '../components/ContactInfoBoxes';

export default function ContactUs() {
  return (
    <WebpageShell
      navProps={{ addAnnouncementBar: false, isRecPrototypePage: false }}
      showCTA={true}
      showFooter={true}
    >
      <HelmetTemplate
        title="Contact - Match Medic"
        description="Contact Match Medic – Find our location, reach out via phone, or send us an email. We're here to help you find the right hair transplant clinic."
        canonicalUrl={`https://matchmedic.com/contact`}
      />

      {/* Map (stretches full width of the content area) */}
      <section className="md:mt-6">
        <ContactMap />
      </section>

      {/* Contact details */}
      <section className="w-full md:w-4/5 mx-auto mt-6 mb-6">
        <ContactInfoBoxes />
      </section>
    </WebpageShell>
  );
}
